export default {
  'menu.welcome': 'Welcome Page',
  'menu.dashboard': 'Dashboard',
  'menu.home': 'Home',
  'menu.login': 'Login',

  // System Management Module
  'menu.system': 'System Management',
  'menu.system.dict': 'Dictionary Management',
  'menu.system.menu': 'Menu Management',
  'menu.system.role': 'Role Management',
  'menu.system.sysConfig': 'System Configuration',
  'menu.system.noAuth': 'No Auth Interface',

  // Event Management Module
  'menu.event': 'Event Management',
  'menu.event.eventRecord': 'Event Record',
  'menu.event.eventOrder': 'Event Order',
  'menu.event.eventOrderNode': 'Order Node',
  'menu.event.eventReceiver': 'Event Receiver',
  'menu.event.resourceFile': 'Resource File',
  'menu.event.eventType': 'Event Type',

  // Organization Management Module
  'menu.organization': 'Organization Management',
  'menu.organization.orgDept': 'Department Management',
  'menu.organization.orgPost': 'Position Management',
  'menu.organization.orgTree': 'Subordinate Organizations',
  'menu.organization.employee': 'Employee Management',
  // Nested Route Internationalization Keys
  'menu.organization.orgTree.orgDept': 'Department Management',
  'menu.organization.orgTree.employee': 'Employee Management',
  'menu.organization.orgTree.orgPost': 'Position Management',

  // Device Management Module
  'menu.device': 'Device Management',
  'menu.device.deviceModel': 'Device Model',
  'menu.device.deviceSupplier': 'Device Supplier',
  'menu.device.deviceGateway': 'Device Gateway',
  'menu.device.deviceTerminal': 'Device Terminal',
  'menu.device.deviceManagement': 'Device Management',

  // Package Management Module
  'menu.package': 'Package Management',
  'menu.package.myPackage': 'My Packages',
  'menu.package.subPackage': 'Child Packages',

  // User Management
  'menu.user': 'User Management',

  // Video Fusion Module
  'menu.video': 'Video Fusion',
  'menu.video.preview': 'Real-time Preview',
  'menu.video.playback': 'History Playback',
  'menu.video.recording': 'Manual Recording',
  'menu.video.fileManagement': 'Video File Management',
  'menu.video.recordingRecord': 'Recording Record Management',
};
